import { PATH_COLABORADOR_DETAIL } from '../../../../navigation/navigation.module';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../../../../services/dashboard-service';
import { Router } from '@angular/router';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'colaboradores-dialog',
  templateUrl: './colaboradores-dialog.component.html',
  styleUrls: ['./colaboradores-dialog.component.scss']
})
export class ColaboradoresDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  logrosColaboradores = [];
  colaboradoresPage = 0;
  PAGE_SIZE: number = 10;

  blockFetch: boolean = false;

  private scrollSubscriber;

  constructor(private dashboardService: DashboardService,
              public dialogRef: MdDialogRef<ColaboradoresDialogComponent>,
              private router: Router) { }

  ngOnInit() {
    this.loadColaboradores();
  }

  loadColaboradores() {
    this.dashboardService.getLogrosColaboradores(this.colaboradoresPage, this.PAGE_SIZE)
      .subscribe(data => {
        console.log(data);
        this.logrosColaboradores = [...this.logrosColaboradores, ...data.ResponseData];
        this.blockFetch = false;
      });
  }

  navigateToColaborador(colaborador){
    this.dialogRef.close();
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.ColaboradorId]);
  }

  ngAfterViewInit(): void {
    const content = document.getElementById('colaboradores-scroll');
    
    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        let max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7 && !this.blockFetch){
          this.blockFetch = true;
          this.colaboradoresPage++;
          this.loadColaboradores();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/colaboradores-dialog/colaboradores-dialog.component.ts